import { CartActionType } from './action.type';

export const CartMutations = {
    [CartActionType.SelectedCart](state, cartSelected) {
        state.cartSelected = cartSelected
    }
}